export const PRIMARY_SPECIALTIES = [
  { code: "art_advisor", fr: "Art Advisor", en: "Art Advisor", de: "Art Advisor" },
  { code: "art_expert", fr: "Expert en art", en: "Art Expert", de: "Kunstsachverständige/r" },
  { code: "collection_manager", fr: "Gestionnaire de collection / Registrar", en: "Collection Manager / Registrar", de: "Sammlungsmanager/in / Registrar" },
  { code: "conservator", fr: "Conservateur-restaurateur", en: "Conservator-Restorer", de: "Konservator/in-Restaurator/in" },
  { code: "art_insurance", fr: "Conseil en assurance d’art", en: "Fine Art Insurance Advisor", de: "Kunstversicherungsberatung" },
  { code: "art_logistics", fr: "Transport et logistique d’art", en: "Fine Art Transport & Logistics", de: "Kunsttransport und -logistik" },
  { code: "legal_tax", fr: "Conseil juridique, fiscal ou successoral", en: "Legal, Tax or Estate Advisor", de: "Rechts-, Steuer- oder Nachfolgeberatung" },
  { code: "philanthropy", fr: "Conseil en mécénat et prêts institutionnels", en: "Philanthropy & Institutional Loans Advisor", de: "Beratung für Mäzenatentum und institutionelle Leihgaben" },
  { code: "secondary_market", fr: "Conseil en vente et marché secondaire", en: "Sales & Secondary Market Advisor", de: "Verkaufs- und Sekundärmarktberatung" },
];

export const SERVICE_OPTIONS = [
  ["collection_strategy", "Conseil et stratégie de collection", "Collection strategy", "Sammlungsstrategie"],
  ["inventory", "Inventaire et documentation", "Inventory and documentation", "Inventar und Dokumentation"],
  ["valuation", "Estimation et valorisation", "Valuation", "Bewertung"],
  ["authentication", "Expertise et authentification", "Expertise and authentication", "Expertise und Authentifizierung"],
  ["acquisition", "Acquisition", "Acquisition", "Erwerb"],
  ["sale", "Vente et arbitrage", "Sale and deaccession", "Verkauf und Deakzession"],
  ["insurance", "Assurance", "Insurance", "Versicherung"],
  ["conservation", "Conservation", "Conservation", "Konservierung"],
  ["transport_storage", "Transport et stockage", "Transport and storage", "Transport und Lagerung"],
  ["estate", "Succession et transmission", "Estate and succession", "Nachlass und Nachfolge"],
  ["loans_philanthropy", "Prêt, donation et mécénat", "Loans, donations and philanthropy", "Leihgaben, Schenkungen und Mäzenatentum"],
].map(([code, fr, en, de]) => ({ code, fr, en, de }));

export const ART_DOMAIN_OPTIONS = [
  ["old_masters", "Art ancien", "Old Masters", "Alte Meister"],
  ["modern_art", "Art moderne", "Modern Art", "Moderne Kunst"],
  ["postwar", "Après-guerre", "Post-War Art", "Nachkriegskunst"],
  ["contemporary", "Art contemporain", "Contemporary Art", "Zeitgenössische Kunst"],
  ["photography", "Photographie", "Photography", "Fotografie"],
  ["design", "Design", "Design", "Design"],
  ["prints", "Estampes et multiples", "Prints and Multiples", "Druckgrafik und Multiples"],
  ["decorative_arts", "Arts décoratifs", "Decorative Arts", "Angewandte Kunst"],
  ["digital_art", "Art numérique", "Digital Art", "Digitale Kunst"],
  ["asian_art", "Arts d’Asie", "Asian Art", "Asiatische Kunst"],
  ["african_art", "Arts d’Afrique", "African Art", "Afrikanische Kunst"],
  ["other", "Autre domaine", "Other field", "Anderes Gebiet"],
].map(([code, fr, en, de]) => ({ code, fr, en, de }));

export function languageKey(language) {
  const lang = String(language || "fr").toLowerCase();
  return lang.startsWith("de") ? "de" : lang.startsWith("en") ? "en" : "fr";
}

export function optionLabel(options, code, language = "fr") {
  const item = options.find((entry) => entry.code === code);
  return item?.[languageKey(language)] || item?.fr || code || "";
}

export function normalizePrimarySpecialty(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (PRIMARY_SPECIALTIES.some((entry) => entry.code === raw)) return raw;
  const v = raw.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  if (v.includes("advisor") || v.includes("conseil en art")) return "art_advisor";
  if (v.includes("registrar") || v.includes("regisseur") || v.includes("gestionnaire de collection")) return "collection_manager";
  if (v.includes("restaur") || v.includes("conservat")) return "conservator";
  if (v.includes("assur")) return "art_insurance";
  if (v.includes("transport") || v.includes("logist")) return "art_logistics";
  if (v.includes("jurid") || v.includes("fiscal") || v.includes("success")) return "legal_tax";
  if (v.includes("mecen") || v.includes("philanth") || v.includes("institution")) return "philanthropy";
  if (v.includes("vente") || v.includes("auction") || v.includes("marche secondaire")) return "secondary_market";
  if (v.includes("expert")) return "art_expert";
  return "";
}

export function parseExpertiseDetails(value) {
  if (!value) return { services: [], domains: [], otherDomain: "" };
  if (typeof value === "object") return {
    services: Array.isArray(value.services) ? value.services : [],
    domains: Array.isArray(value.domains) ? value.domains : [],
    otherDomain: String(value.otherDomain || ""),
  };
  try { return parseExpertiseDetails(JSON.parse(value)); }
  catch { return { services: [], domains: [], otherDomain: String(value).trim() }; }
}

export function serializeExpertiseDetails(value) {
  return JSON.stringify(parseExpertiseDetails(value));
}
